import { ConsentBody } from "../shared/ConsentBody.js";
import { ConsentCheckboxLabel } from "../shared/ConsentCheckboxLabel.js";
import { useTranslation } from "react-i18next";
import { Body2, Checkbox, ConditionalComponent, Flex, Heading1, Stack } from "@myphx-engineering/phx-design-system";
import { constants, formatDate } from "@myphx-engineering/phx-design-system/framework";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/consent-details/ConsentDetails.tsx
const ConsentDetails = ({ activityDate, consent, isAttested, shouldAllowConsentAttestation, status, onCheckboxChange }) => {
	const { t } = useTranslation("cons");
	const versionNumber = Number.isSafeInteger(consent?.majorVersion) && Number.isSafeInteger(consent?.minorVersion) ? `${consent.majorVersion}.${consent.minorVersion}` : void 0;
	let statusLabel = "";
	switch (status) {
		case "ACTIVE":
			statusLabel = t("consentStatus.accepted");
			break;
		case "DECLINED":
			statusLabel = t("consentStatus.declined");
			break;
		case "REVOKED":
			statusLabel = t("consentStatus.revoked");
			break;
	}
	const handleCheckboxChange = (isChecked) => {
		onCheckboxChange?.(consent.id, isChecked);
	};
	return /* @__PURE__ */ jsx(Stack, {
		gap: "lg",
		children: /* @__PURE__ */ jsxs(Stack, {
			gap: "sm",
			children: [
				/* @__PURE__ */ jsx(Heading1, { children: consent.title }),
				/* @__PURE__ */ jsxs(Flex, {
					gap: "xxxs",
					children: [/* @__PURE__ */ jsx(Body2, {
						bold: true,
						children: consent?.required ? t("consents.required") : t("consents.optional")
					}), versionNumber && /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(Body2, { children: constants.unicode.BULLET }), /* @__PURE__ */ jsx(Body2, { children: t("consents.version", { version: versionNumber }) })] })]
				}),
				activityDate && status && /* @__PURE__ */ jsx(Body2, { children: t("consentDetails.activityDate", {
					status: statusLabel,
					activityDate: formatDate(Date.parse(activityDate))
				}) }),
				/* @__PURE__ */ jsx(ConsentBody, {
					consent,
					status
				}),
				/* @__PURE__ */ jsx(ConditionalComponent, {
					condition: shouldAllowConsentAttestation,
					children: /* @__PURE__ */ jsx(Checkbox, {
						label: /* @__PURE__ */ jsx(ConsentCheckboxLabel, { consent }),
						checked: isAttested,
						onChange: handleCheckboxChange
					})
				})
			]
		})
	});
};

//#endregion
export { ConsentDetails };